// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PCalendarCheckOutlinedSvg from "@fishx/icons-svg/es/asn/PCalendarCheckOutlined";
import FishxIcon from '../components/FishxIcon';

var PCalendarCheckOutlined = function PCalendarCheckOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PCalendarCheckOutlinedSvg
  }));
};

PCalendarCheckOutlined.displayName = 'PCalendarCheckOutlined';
export default React.forwardRef(PCalendarCheckOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PCalendarCheckOutlined.js
// module id = 3257
// module chunks = 0